import { put, call } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadDailyTariffByIdFailed,
  loadDailyTariffByIdSuccessful,
} from '../actions';

export default function* loadDailyTariffById(action) {
  try {
    const id = action.payload;

    const url = `${BACKEND_URL}/proxy/tariff/v1/daily-tariffs/${id}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();

    if (dataResponse.status === OK) {
      yield put(loadDailyTariffByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadDailyTariffByIdFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadDailyTariffByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
